import { massDispatchAdapter } from './reducer'

export const { selectAll: selectAllSettings } = massDispatchAdapter.getSelectors(
  state => state.massDispatch
)
